import script from "./SubareaGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./SubareaGuide.vue?vue&type=script&setup=true&lang=js"

import "./SubareaGuide.vue?vue&type=style&index=0&id=dc195b00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc195b00"]])

export default __exports__